import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ArticlePage from "./pages/ArticlePage";
import SearchPage from "./pages/SearchPage";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ArticleEditor from "./pages/admin/ArticleEditor";
import Users from "./pages/admin/Users";
import Inbox from "./pages/admin/Inbox";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import ChatBubble from "./components/ChatBubble";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (read hash from useLocation, not window)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/recherche" element={<SearchPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/a-la-une" element={<CategoryPage featuredPage />} />
      <Route path="/rubrique/:slug" element={<CategoryPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="articles/new" element={<ArticleEditor />} />
        <Route path="articles/:id/edit" element={<ArticleEditor />} />
        <Route path="users" element={<Users />} />
        <Route path="messages" element={<Inbox />} />
      </Route>
      <Route path="/:category/:slug" element={<ArticlePage />} />
    </Routes>
    <ChatBubble />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
